import EfLogoIconV1 from 'eco-design/section-layout/ef-nav-common/EfLogoIconV1';
import GlobalLocaleV1 from 'eco-design/section-layout/ef-nav-common/GlobalLocaleV1';
import { useEffect, useState } from 'react';
import { localValueMap } from '@/utils/locals';

export default function FooterB1({ locale, theme = 'black' }: { locale: string; theme: 'white' | 'black' | 'gray' }) {
    const [languageRegion, setLanguageRegion] = useState('');
    useEffect(() => {
        const curLocal = localValueMap[locale] || localValueMap['en'];
        if (Object.keys(curLocal).length !== 0) {
            // @ts-ignore
            const text = curLocal.local === 'us' ? `${curLocal?.regionText} (${curLocal?.languageText})` : `${curLocal?.regionText}(${curLocal?.languageText})`;
            setLanguageRegion(text);
        }
    }, [locale]);
    return (
        <div className={`footer-FooterB1 footer-FooterB1-theme-${theme}`}>
            <div className="footer-FooterB1-l">
                <EfLogoIconV1 />
            </div>
            <div className="footer-FooterB1-r">
                <GlobalLocaleV1 title={languageRegion} />
            </div>
        </div>
    );
}
